import { RootReducer } from '../../../store/types';

export const selectDynamicContent = (state: RootReducer) =>
  state.shareReducer.cspData;
export const selectAppealCategories = (state: RootReducer) =>
  state.CSPReducer.appealCategories;
export const selectVettingSettings = (state: RootReducer) =>
  state.CSPReducer.vettingSettings;
export const selectCountries = (state: RootReducer) =>
  state.CSPReducer.countries;
export const selectBrandIdentityStatus = (state: RootReducer) =>
  state.CSPReducer.brandIdentityStatus;
export const selectLoaStatus = (state: RootReducer) =>
  state.CSPReducer.loaStatus;
export const selectStockExchanges = (state: RootReducer) =>
  state.CSPReducer.stockExchanges;
export const selectTrademarkVerificationStatus = (state: RootReducer) =>
  state.CSPReducer.trademarkVerificationStatus;
export const selectVerticalTypes = (state: RootReducer) =>
  state.CSPReducer.verticalTypes;
export const selectDcas = (state: RootReducer) => state.CSPReducer.dcas;
export const selectPatentOffices = (state: RootReducer) =>
  state.CSPReducer.patentOffices;
